/**
 * Abaco Brands — Teacher Toolkit Thank You page (Part 8)
 *
 * - Copies the coupon code to the clipboard on click.
 * - If a Path B backend issued a verification token (?t=...), pings it to
 *   confirm the lead was recorded server-side and fires a download-ready
 *   status message. Purely cosmetic/best-effort — the download buttons are
 *   already rendered from Liquid blocks regardless (see architecture notes
 *   in README.md about soft vs hard gating).
 * - Fires a dataLayer/GA4 event per download click for funnel reporting.
 */
(function () {
  'use strict';

  function initCouponCopy() {
    var copyBtn = document.querySelector('[data-ttk-copy-coupon]');
    var codeEl = document.querySelector('[data-ttk-coupon-code]');
    if (!copyBtn || !codeEl) return;

    copyBtn.addEventListener('click', function () {
      var code = codeEl.textContent.trim();
      var restoreLabel = copyBtn.textContent;

      function onCopied() {
        copyBtn.textContent = 'Copied!';
        window.setTimeout(function () {
          copyBtn.textContent = restoreLabel;
        }, 2000);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(onCopied).catch(function () {
          fallbackCopy(code, onCopied);
        });
      } else {
        fallbackCopy(code, onCopied);
      }
    });
  }

  function fallbackCopy(text, done) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
      done();
    } catch (e) {
      /* clipboard unavailable — user can still select/copy manually */
    } finally {
      document.body.removeChild(textarea);
    }
  }

  /**
   * Cosmetic only: reads ?name= (forwarded from the popup/hero form, never
   * persisted to Shopify — see teacher-toolkit.js) and prepends a "Thanks,
   * {name}!" greeting to the headline. Falls back silently to the plain
   * headline when no name is present.
   */
  function initGreeting() {
    var greetingEl = document.querySelector('[data-ttk-greeting-name]');
    if (!greetingEl) return;

    var params = new URLSearchParams(window.location.search);
    var name = (params.get('name') || '').trim();
    if (!name) return;

    // Keep it short and sane even if a very long value is passed in the URL.
    name = name.slice(0, 40);

    greetingEl.textContent = 'Thanks, ' + name + '! ';
    greetingEl.hidden = false;
  }

  function initVerification() {
    var statusEl = document.querySelector('[data-ttk-verify-status]');
    var params = new URLSearchParams(window.location.search);
    var token = params.get('t');
    if (!token || !statusEl) return;

    var config = window.TeacherToolkitConfig || {};
    var verifyEndpoint = config.verifyEndpoint || '/apps/toolkit/verify';

    statusEl.hidden = false;
    statusEl.textContent = 'Confirming your download...';

    fetch(verifyEndpoint + '?t=' + encodeURIComponent(token), { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && data.verified) {
          statusEl.textContent = 'Your toolkit files are ready below.';
        } else {
          statusEl.hidden = true; // no backend / not verified — stay silent, buttons already work
        }
      })
      .catch(function () {
        statusEl.hidden = true;
      });
  }

  function initDownloadTracking() {
    document.querySelectorAll('[data-ttk-download-link]').forEach(function (link) {
      link.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'teacher_toolkit_download',
          file_label: link.getAttribute('data-ttk-file-label') || ''
        });
      });
    });
  }

  function init() {
    initGreeting();
    initCouponCopy();
    initVerification();
    initDownloadTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
